import './App.css';


import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import Home from './components/Home/Home';
import ProjectDetail from './components/ProjectDetail/ProjectDetail';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/projectDetail/:id" element={<ProjectDetail />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
